<template>
  <el-card shadow="never" style="overflow: visible">
    <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="85px">
      <el-row :gutter="15">
        <el-col :sm="8">
          <el-form-item label="工作组:" prop="groupIds">
            <el-select v-model="editForm.groupIds" placeholder="请选择工作组" class="ele-block" multiple>
              <el-option v-for="(item, index) in groupList" :key="index" :label="item.groupName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="短信内容:" prop="detail">
            <el-input type="textarea" :rows="6" v-model="editForm.detail" maxlength="130" show-word-limit />
          </el-form-item>
          <el-form-item label="定时发送：">
            <el-switch v-model="isSendTime" />
          </el-form-item>
          <el-form-item v-show="isSendTime" label="选择日期：">
            <el-date-picker v-model="sendDate" type="datetime" placeholder="选择日期时间" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="saveDetail()">发 送</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import { getTeacherAllGroup, sendMessageByGroup } from '@/config/api';

  export default {
    name: 'FromGroup',
    data() {
      return {
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          groupIds: [{ required: true, message: '请选择工作组', trigger: 'blur' }],
          detail: [{ required: true, message: '请输入短信内容', trigger: 'blur' }],
        },
        groupList: [], //角色列表
        sendDate: '',
        isSendTime: false,
      };
    },
    mounted() {
      this.queryGroup();
    },
    methods: {
      /* 查询角色列表 */
      queryGroup() {
        getTeacherAllGroup().then((res) => {
          if (res.data.resCode == 200) {
            this.groupList = res.data.data;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },

      // 发送短信
      saveDetail() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            if (this.isSendTime) {
              if (this.sendDate != '') {
                this.editForm.time = this.$util.toDateString(this.sendDate, 'yyyy-MM-dd HH:mm');
              } else {
                this.$message.error('请选择发送日期');
                return false;
              }
            }
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            sendMessageByGroup(formData).then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs['editForm'].resetFields();
                this.sendDate = '';
                this.isSendTime = false;
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped></style>
